import React from 'react';
import { useUi } from '../context/UiContext';
import { t } from '../i18n';
import Seo from '../components/Seo';

export default function Who() {
  const { lang } = useUi();
  return (
    <section className="hero">
      <Seo title={t(lang, 'who.title')} description={t(lang, 'who.desc')} />
      <h1 className="hero-title">{t(lang, 'who.title')}</h1>
      <p className="hero-subtitle">{t(lang, 'who.desc')}</p>

      <div className="section-title">What we do</div>
      <ul>
        <li>AI strategy, applied machine learning, and responsible adoption</li>
        <li>Full-stack platforms: web, mobile, and cloud-native systems</li>
        <li>Rapid R&D, prototyping, and product acceleration</li>
        <li>IoT, edge computing, and smart device experiences</li>
        <li>Modern data and analytics foundations</li>
      </ul>

      <div className="section-title" style={{ marginTop: 28 }}>{t(lang, 'who.partners')}</div>
      <div className="grid">
        <div className="card"><div className="card-body"><h3 className="card-title">3Dots LLC</h3><p className="card-desc">Product strategy, cloud migration, and data platforms.</p></div></div>
        <div className="card"><div className="card-body"><h3 className="card-title">Amazon</h3><p className="card-desc">AWS architectures, serverless, and applied AI.</p></div></div>
        <div className="card"><div className="card-body"><h3 className="card-title">Amazon Robotics</h3><p className="card-desc">Autonomous systems, perception, and large-scale automation.</p></div></div>
        <div className="card"><div className="card-body"><h3 className="card-title">Grote Industries</h3><p className="card-desc">BLE-enabled truck safety lights: hardware innovation, prototyping & firmware, plus app design for reliable BLE signaling.</p></div></div>
        <div className="card"><div className="card-body"><h3 className="card-title">Google</h3><p className="card-desc">Cloud, MLOps, and modern web experiences.</p></div></div>
        <div className="card"><div className="card-body"><h3 className="card-title">Energy & Utilities</h3><p className="card-desc">Grid analytics, smart metering, and reliability.</p></div></div>
        <div className="card"><div className="card-body"><h3 className="card-title">Federal Reserve Bank (St. Louis)</h3><p className="card-desc">Cloud migration for critical workloads; compliance with federal mandates and security (e.g., FIPS).</p></div></div>
        <div className="card"><div className="card-body"><h3 className="card-title">Cigna</h3><p className="card-desc">Mental health onboarding and patient management app: React Native, SwiftUI, and Android native.</p></div></div>
        <div className="card"><div className="card-body"><h3 className="card-title">Bayer</h3><p className="card-desc">Support across multiple application development and implementation initiatives.</p></div></div>
      </div>

    </section>
  );
}


